export const settingsDefault = {
    logo: {
        name: '',
        file: null,
        url: '',
        ref: 'logo'
    },
    background: {
        name: '',
        file: null,
        url: '',
        ref: 'background'
    },
    imgCurriculo: {
        name: '',
        file: null,
        url: '',
        ref: 'imgCurriculo'
    },
    blog: '',
    whatsapp: '',
    prominentTitle: {
        ref: 'prominentTitle',
        value: '',
        ToggleView: false,
    },
    attendance: '',
    books: '',
    speeches: '',
    courses: '',
    textCurriculo: {
        ref: 'textCurriculo',
        value: '',
        ToggleView: false,
    }
}